import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { OrderListRoutingModule } from './order-list-routing.module';
import { OrderListComponent } from './order-list.component';
import { ModalModule } from 'ngx-bootstrap/modal';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';


@NgModule({
  declarations: [OrderListComponent],
  imports: [
    CommonModule,
    FormsModule, ReactiveFormsModule,
    NgbModule,
    ModalModule.forRoot(),
    OrderListRoutingModule
  ]
})
export class OrderListModule { }
